"use client";

import React, { createContext, useMemo } from "react"; // =================================================================================
import { IGlobalDefaultContext, useGlobalContext } from "../../default/global-context";
import { Product } from "src/lib/fetcher/client";

type ICartAction = { type: "CHANGE_CART_AMOUNT"; payload: { product: Product; quantity: number } };

interface ICartContext {
  state: { cart: IGlobalDefaultContext["cartItems"] };
  dispatch: React.Dispatch<ICartAction>;
}
export const CartContext = createContext<ICartContext>({} as any);

export const CartProvider = ({ children }: React.PropsWithChildren) => {
  const { cartItems, updateProductQuantity } = useGlobalContext();
  const contextValue = useMemo<ICartContext>(
    () => ({
      state: { cart: cartItems },
      dispatch: (action) => {
        if (action.type === "CHANGE_CART_AMOUNT") {
          updateProductQuantity(action.payload);
        }
      },
    }),
    [cartItems],
  );
  return <CartContext.Provider value={contextValue}>{children}</CartContext.Provider>;
};
export default CartProvider;
